import React from "react";

const WhyChooseSection = () => {
    const features = [
        {
            id: 1,
            title: "Free to Use",
            description: "Access all basic recording features without any cost: no hidden payments, activation fees, or extra charges.",
            icon: "/img/whyChooseSection/free-icon.png",
        },
        {
            id: 2,
            title: "User-friendly",
            description:
                "The Voice Recorder's clean, simple interface offers a smooth, hassle-free experience, making it easy for anyone to record audio.",
            icon: "/img/whyChooseSection/user-friendly-icon.png",
        },
        {
            id: 3,
            title: "No Software Installation",
            description:
                "Record directly from your browser without downloading apps, saving you time and storage space on your device.",
            icon: "/img/whyChooseSection/no-software-icon.png",
        },
        {
            id: 4,
            title: "Unlimited Recording",
            description:
                "Record as much audio as you need with no time limits, allowing you to capture long sessions without worrying about restrictions.",
            icon: "/img/whyChooseSection/unlimited-icon.png",
        },
        {
            id: 5,
            title: "High-Quality Audio",
            description:
                "Capture clear, crisp audio with minimal effort, ensuring professional-grade recordings every time, whether for personal or professional use.",
            icon: "/img/whyChooseSection/high-quality-icon.png",
        },
        {
            id: 6,
            title: "Secure",
            description:
                "Your recordings are kept safe, with strong security measures to protect your data and maintain privacy.",
            icon: "/img/whyChooseSection/secure-icon.png",
        },
    ];

    return (
        <div className="container py-5">
            <h2 className="text-center mb-5" style={{ fontFamily: "Metropolis", fontWeight: "700", fontSize: "34px" }}>
                Why Choose Our Online Voice Recorder?
            </h2>
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {features.map((feature) => (
                    <div key={feature.id} className="col">
                        <div className="card h-100 text-center border-0">
                            <div className="card-body" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                <div className="mb-3">
                                    <img
                                        src={feature.icon}
                                        alt={feature.title}
                                        className="img-fluid"
                                        style={{ height: "54px", width: "54px", objectFit: "contain" }}
                                    />
                                </div>
                                <p className="" style={{ fontFamily: "Metropolis", fontWeight: "700", fontSize: "20px" }}>{feature.title}</p>
                                <p className="" style={{ textAlign: "justify", color: "#5F626B", fontFamily: "Metropolis", fontWeight: "500", fontSize: "16px", lineHeight: "22px" }}>{feature.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WhyChooseSection;
